import React, { useEffect, useState } from "react";
import * as cls from "./certificatesList.module.scss";
import { useSelector } from "react-redux";
import { Icon } from "../../../personal-studio-components/frame";
import { StudentService } from "../studentService";
import ModalMessage from "../modalMessage/ModalMessage";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import { ErrataView } from "../../../personal-studio-components/service";
import { Button } from "../../../personal-studio-components/form";

function CertificatesList({ getList, data, setData }) {
  const [sortOrder, setSortOrder] = useState("asc");
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [status, setStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [aprooveDelete, setAprooveDelete] = useState(false);
  const [id, setId] = useState(null);
  async function deleteCertificate(id) {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/delete",
        data: {
          access_token,
          study_contract_id: contractId,
          certificate_event_id: id,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          if (response.errors && response.error_type !== "auth") {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
          } else {
            getList();
          }
          handleClose();
        }
      });
    }
  }
  async function certificatesSend(id) {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/certificates/send",
        data: {
          access_token,
          study_contract_id: contractId,
          certificate_event_id: id,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          if (!response.errors) {
            setStatus(response.status);
            setOpen(true);
          }
        }
      });
    }
  }
  //  function parseDate(dateStr) {
  //    const parts = dateStr.split(".");
  //    return new Date(parts[2], parts[1] - 1, parts[0]);
  //  }

  function handleSort() {
    const sortedData = [...data].sort((a, b) => {
      const dateA = /*parseDate*/ new Date(a.sys_creation_date);
      const dateB = /*parseDate*/ new Date(b.sys_creation_date);

      if (sortOrder === "asc") {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    setData(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  }
  const handleClose = () => {
    setAprooveDelete(false);
  };
  useEffect(() => {
    getList();
  }, []);

  if (data && data.errors) {
    return (
      <>
        {data.error_type === "info" ? (
          <ErrataViewInfo errata={data} />
        ) : (
          <ErrataView errata={data} />
        )}
      </>
    );
  }

  if (data && !data.errors)
    return (
      <div className={cls.table_container}>
        <div className={`${cls.table} ${cls.flex_table}`}>
          <div className={`${cls.row} ${cls.header}`}>
            <div className={cls.cell} onClick={handleSort}>
              Дата заявки {sortOrder === "asc" ? "↑" : "↓"}
            </div>
            <div className={cls.cell}>Вид справки</div>
            <div className={cls.cell}>Состояние</div>
            <div className={cls.cell}></div>
          </div>
          {data.map(
            (
              {
                sys_creation_date,
                certificate_type_name,
                state_name,
                certificate_event_id,
                url,
                certificate_state_id,
              },
              idx
            ) => (
              <div key={idx} className={cls.row}>
                <div className={cls.cell}>
                  {new Date(sys_creation_date).toLocaleDateString()}
                </div>
                <div className={cls.cell}>{certificate_type_name}</div>
                <div className={cls.cell}>{state_name}</div>
                <div className={cls.cell}>
                  {/* В "Заявки / Справки" реализован просмотр макета */}
                  {certificate_state_id !== 3 ? (
                    <>
                      <a href={url} target="_blank">
                        <Icon name="search" />
                      </a>{" "}
                      {certificate_state_id === 1 && (
                        <a
                          href="#delete"
                          data-certificate_event_id={certificate_event_id}
                          onClick={() => {
                            setId(certificate_event_id);
                            setAprooveDelete(true);
                          }}
                        >
                          <Icon name="delete" />
                        </a>
                      )}
                    </>
                  ) : (
                    <a
                      href="#open"
                      onClick={() => certificatesSend(certificate_event_id)}
                    >
                      <Icon name="clipboard_list" />
                    </a>
                  )}
                </div>
              </div>
            )
          )}
          <Dialog open={aprooveDelete} onClose={handleClose}>
            <DialogTitle>Подтвердите действие</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Вы действительно хотите удалить?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={onDelete}>Удалить</Button>
              <Button onClick={handleClose} type="primary">
                Назад
              </Button>
            </DialogActions>
          </Dialog>
          {open && (
            <ModalMessage
              title="Оформление справки"
              message={status}
              open={open}
              setOpen={setOpen}
              onClose={() => {}}
            />
          )}
        </div>
      </div>
    );

  return null;
  // Обработчик иконки "Удалить"
  function onDelete(event) {
    deleteCertificate(id);
  }
}

export default CertificatesList;
